import { type ReactElement, type ReactNode } from 'react';
import styled from 'styled-components';
import Footer from '../../components/Footer';
import LazySelectLanguage from '../../components/LazySelectLanguage';
import breakpoints from '../../utilities/breakpoints';
import LanguageContainer from '../../utilities/LanguageContainer';
import ErrorBoundary from '../ErrorBoundary';

const Container = styled.div`
    padding: 0px;
    min-height: 100vh;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    @media (max-width: ${breakpoints.sm}) {
        padding: 0px;
        margin: 0px;
    }
`;

export type LoginLayoutProps = { children: JSX.Element | ReactNode | ReactElement };

const LoginLayout = ({ children }: LoginLayoutProps) => (
    <Container>
        <ErrorBoundary>
            <LanguageContainer>
                <LazySelectLanguage />
            </LanguageContainer>
            {children}
            <Footer />
        </ErrorBoundary>
    </Container>
);

export default LoginLayout;
